"use client"

import dynamic from "next/dynamic"
import { useState, type ReactNode } from "react"
import { useTranslations } from "next-intl"
import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"

const TemplateManager = dynamic(() => import("./template-manager"), { ssr: false, loading: () => <Loader2 className="h-4 w-4 animate-spin" /> })
export function ManageTemplatesButton({ channelId, children }: { channelId: string; children?: ReactNode }) {
  const t = useTranslations("WhatsappTemplates")
  const [open, setOpen] = useState(false)
  return <>
    <Button type="button" variant="link" className="h-auto whitespace-normal p-0 text-left text-sm text-blue-600 underline-offset-4 hover:underline" onClick={() => setOpen(true)}><span>{children ?? t("manage")}</span></Button>
    {open ? <TemplateManager key={channelId} channelId={channelId} open={open} onOpenChange={setOpen} /> : null}
  </>
}
